import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const Home = forwardRef<SVGSVGElement, SvgIconProps>(function Home(props, ref) {
  return (
    <SvgIcon ref={ref} {...props}>
      <path d="M18.9,20h-4.6v-4.9H9.7V20H5.1v-7.4c-0.6,0-1.1-0.6-1.1-1.2L12,4l3.4,3.2V5.2h2.3v4l2.3,2.1c0,0.7-0.5,1.2-1.1,1.2V20z" />
    </SvgIcon>
  )
})

export default Home
